/* eslint-disable @typescript-eslint/no-misused-promises */
import { useFetchUser } from '@/hooks';
import type { IAddressBook, IAuthSignupFields } from '@/types';
import { Flex, Modal, useDisclosure } from '@chakra-ui/react';
import { useState } from 'react';
import { useUserApi } from '../api';
import { EmptyAddressCard, SettingCard } from './SettingCard';
import {
  SettingsAddAddressBookModal,
  SettingsDeleteAddressModal,
  SettingsModifyAddressBookModal,
} from './userSettings';

export const DeliveryAddressBook = (): JSX.Element => {
  // eslint-disable-next-line use-encapsulation/prefer-custom-hooks
  const [selectedAddressId, setSelectedAddressId] = useState<string>();
  const { fetch: updateUser, user } = useFetchUser();
  const userApi = useUserApi();
  // eslint-disable-next-line use-encapsulation/prefer-custom-hooks
  const [isModifyLoading, setIsModifyLoading] = useState<boolean>(false);

  const {
    isOpen: isOpenAddressBook,
    onClose: onCloseAddressBook,
    onOpen: onOpenAddressBook,
  } = useDisclosure();

  const {
    isOpen: isOpenModifyAddressBook,
    onClose: onCloseModifyAddressBook,
    onOpen: onOpenModifyAddressBook,
  } = useDisclosure();

  const {
    isOpen: isOpenDeleteAddress,
    onClose: onCloseDeleteAddress,
    onOpen: onOpenDeleteAddress,
  } = useDisclosure();

  //TODO[REFACTORING] try UseReducer for three handlers

  const handleSettingAddressBook = async (data: IAddressBook): Promise<void> => {
    setIsModifyLoading(true);

    if (user) {
      const updatedUser: IAuthSignupFields = {
        ...user,
        deliveryAddressBook: [...user.deliveryAddressBook, data],
      };

      await userApi.updateUser(updatedUser);
      updateUser();
    }

    setIsModifyLoading(false);

    onCloseAddressBook();
  };

  const handleSettingModifyAddressBook = async (data: IAddressBook): Promise<void> => {
    setIsModifyLoading(true);

    if (user) {
      user.deliveryAddressBook.forEach((item, i) => {
        if (item.id === selectedAddressId)
          user.deliveryAddressBook[i] = { ...data, id: selectedAddressId };
      });

      const updatedUser: IAuthSignupFields = {
        ...user,
        deliveryAddressBook: user.deliveryAddressBook,
      };

      await userApi.updateUser(updatedUser);
      updateUser();
    }

    setIsModifyLoading(false);

    onCloseModifyAddressBook();
  };

  const handleDeleteAddress = async (): Promise<void> => {
    if (user) {
      const newDeliveryAddressBook = user.deliveryAddressBook.filter(
        (address) => address.id !== selectedAddressId
      );

      const updatedUser: IAuthSignupFields = {
        ...user,
        deliveryAddressBook: newDeliveryAddressBook,
      };

      await userApi.updateUser(updatedUser);
      updateUser();
    }

    onCloseDeleteAddress();
  };

  return (
    <>
      <Flex flexWrap="wrap" gap="2%" justifyContent="flex-start" rowGap="30px">
        {user && user.deliveryAddressBook.length > 0 ? (
          user.deliveryAddressBook.map((delAddress) => (
            <SettingCard
              address={{
                city: delAddress.city,
                province: delAddress.province,
                streetAddress: delAddress.streetAddress,
                zipCode: delAddress.zipCode,
              }}
              key={delAddress.id}
              title={delAddress.name}
              onDelete={(): void => {
                setSelectedAddressId(delAddress.id);
                onOpenDeleteAddress();
              }}
              onOpen={(): void => {
                setSelectedAddressId(delAddress.id);
                onOpenModifyAddressBook();
              }}
            />
          ))
        ) : (
          <EmptyAddressCard onOpen={onOpenAddressBook} />
        )}
        {user && user.deliveryAddressBook.length > 0 && (
          <EmptyAddressCard onOpen={onOpenAddressBook} />
        )}
      </Flex>
      <Modal
        isOpen={isOpenAddressBook}
        onClose={(): void => {
          onCloseAddressBook();
        }}
      >
        <SettingsAddAddressBookModal
          isLoading={isModifyLoading}
          onClick={handleSettingAddressBook}
        />
      </Modal>

      <Modal
        isOpen={isOpenModifyAddressBook}
        onClose={(): void => {
          onCloseModifyAddressBook();
        }}
      >
        {user?.deliveryAddressBook && (
          <SettingsModifyAddressBookModal
            addressBook={user.deliveryAddressBook}
            id={selectedAddressId}
            isLoading={isModifyLoading}
            onSubmit={handleSettingModifyAddressBook}
          />
        )}
      </Modal>

      <Modal
        isOpen={isOpenDeleteAddress}
        onClose={(): void => {
          onCloseDeleteAddress();
        }}
      >
        <SettingsDeleteAddressModal
          onClose={(): void => onCloseDeleteAddress()}
          onDelete={handleDeleteAddress}
        />
      </Modal>
    </>
  );
};
